//Todo: fix a11y issues
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import PropTypes from 'prop-types';
import { getContextualUrl } from '../scripts/utils';
var ClubFooterStrip = function ClubFooterStrip(_ref) {
  var urlLogo = _ref.urlLogo,
    teamLinks = _ref.teamLinks,
    locale = _ref.locale,
    teamNameSlug = _ref.teamNameSlug,
    isLegacy = _ref.isLegacy;
  var menuItems = teamLinks && teamLinks[0] && teamLinks[0].menuItems;
  var logoHref = getContextualUrl('/', teamNameSlug, locale, isLegacy);
  return /*#__PURE__*/React.createElement("div", {
    className: "site-footer__team-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "site-footer__team-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: logoHref
  }, /*#__PURE__*/React.createElement("img", {
    className: "site-footer__team-url-logo",
    src: urlLogo,
    role: "presentation",
    loading: "lazy"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "site-footer__team-links"
  }, menuItems && menuItems.map(function (teamLink) {
    if (!teamLink) {
      return null;
    }
    var link = teamLink.properties && teamLink.properties.link || '';
    var contextualLink = getContextualUrl(link, teamNameSlug, locale, isLegacy);
    return /*#__PURE__*/React.createElement("li", {
      key: "teamLink-".concat(teamLink.text)
    }, /*#__PURE__*/React.createElement("a", {
      className: "site-footer__team-link",
      href: contextualLink
    }, teamLink.text));
  })));
};
export default ClubFooterStrip;
ClubFooterStrip.propTypes = {
  urlLogo: PropTypes.string.isRequired,
  teamLinks: PropTypes.instanceOf(Object).isRequired,
  locale: PropTypes.string,
  teamNameSlug: PropTypes.string,
  isLegacy: PropTypes.bool
};